module.exports = __webpack_public_path__ + "images/topic-screenshots/simple-machines/Test_InclinedPlane.png";